import Axios from 'axios';
import { ACCOUNT_URL, APIBASE_URL } from '../config/cacheKey';
import {
    ICheckOtpRequest,
    ICheckOtpResponse,
    ISendOtpRequest,
    ISendOtpResponse,
} from '../models/account.model';
import { ApiResultModel } from '../models/common.model';

export const sendOtp = (data: ISendOtpRequest): Promise<ISendOtpResponse> => {
    return Axios.post<ApiResultModel<ISendOtpResponse>>(
        APIBASE_URL + ACCOUNT_URL + '/SendOtp',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const CheckOtp = (
    data: ICheckOtpRequest
): Promise<ApiResultModel<ICheckOtpResponse>> => {
    return Axios.post<ApiResultModel<ICheckOtpResponse>>(
        APIBASE_URL + ACCOUNT_URL + '/CheckOtp',
        data
    ).then((result) => {
        return result.data;
    });
};
export const GetAccessTokenByRefreshToken = (
    data: ICheckOtpResponse
): Promise<ApiResultModel<ICheckOtpResponse>> => {
    return Axios.post<ApiResultModel<ICheckOtpResponse>>(
        APIBASE_URL + ACCOUNT_URL + '/GetAccessTokenByRefreshToken',
        data
    ).then((result) => {
        return result.data;
    });
};

export const SetGoftinoUser = async (
    data: {
        goftinoUserId: string
    }
): Promise<boolean> => {
    return await Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + ACCOUNT_URL + '/SetGoftinoUser',
        data
    ).then((result) => {
        return result.data.data;
    });
};
